/** @jsxImportSource theme-ui */
import { useRouter } from "next/router"
import Image from "next/image"
import Logo from "../../../public/img/logo.svg"

const FooterLogo = () => {
  const router = useRouter()

  return (
    <div
      sx={{
        ":hover": {
          cursor: "pointer"
        }
      }}
      onClick={() => router.push("/")}
    >
      <Image
        src={Logo}
        alt="Bodycam Report logo"
        width={184}
        height={40}
        priority
      />
    </div>
  )
}

export default FooterLogo
